// Shared service that provides access to lookup maps and data retrieval
import { I_VehicleIncidentsTableItem } from "../interfaces"
import VIS from "../VehicleIncidentsService"
import approvalService from "src/components/approvals/ApprovalService"


/**
 * Columns to be displayed in the Vehicle Incidents table.
 * These are used to dynamically render headers and rows in the table UI.
 *
 * width is a preferred width, not a fixed one. Columns shrink from here as the
 * window narrows until the table hits the min-width floor in
 * VehicleIncidentsTable.css, at which point the grid scrolls instead.
 */
const vehicleIncidentsTableItems: I_VehicleIncidentsTableItem[] = [
  {
    title: "Type",
    key: "Name",
    order: 1,
    sortable: true,
    customSortKey: null,
    VISFunction: null,
    width: "160px",
  },
  {
    title: "First Name",
    key: "EmployeeID",
    order: 2,
    sortable: true,
    customSortKey: "FirstName",
    VISFunction: (id: number) => {
      const emp = approvalService.retrieveEmployeeFromMap(id)
      return emp?.FirstName ?? "*NA*"
    },
    width: null,
  },
  {
    title: "Last Name",
    key: "EmployeeID",
    order: 3,
    sortable: true,
    customSortKey: "LastName",
    VISFunction: (id: number) => {
      const emp = approvalService.retrieveEmployeeFromMap(id)
      return emp?.LastName ?? "*NA*"
    },
    width: null,
  },
  {
    title: "Date/Time",
    key: "Time",
    order: 4,
    sortable: true,
    customSortKey: null,
    VISFunction: (time: string) => {
      const date = VIS.formatTimeColumn(time)
      return date
    },
    width: "160px",

  },
  {
    title: "Video",
    key: "SafetyEventUrl",
    order: 5,
    sortable: false,
    customSortKey: null,
    VISFunction: null,
    width: "80px",
  },
  {
    title: "Status",
    key: "Status",
    order: 6,
    sortable: true,
    customSortKey: null,
    VISFunction: (id: number) => {
      const status = VIS.retrieveStatusFromMap(id)
      return status?.Name ?? "New"
    },
    width: "140px",
  },
  {
    // Actions column: holds the hover row menu so its buttons never overlap the Status text.
    // Wide enough for the worst case (6 icons at ~38px each in the Pending view).
    title: "Actions",
    key: "ObjectID",
    order: 7,
    sortable: false,
    customSortKey: null,
    VISFunction: null,
    width: "240px",
    isActionsColumn: true,
  },
].sort((a, b) => a.order - b.order) // Ensure consistent display order

export default vehicleIncidentsTableItems

/**
 * Type alias for valid table column keys (used in sorting, filtering, etc.)
 */
export type VehicleIncidentsTableKey = I_VehicleIncidentsTableItem["key"]
